import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Col, Row, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";

const Calendar = () => {
  const [iframeReady, setIframeReady] = useState(false);

  return (
    <>
      <PageSEO
        title="Tour Event Calendar | American Legacy Tours"
        description="Browse all upcoming American Legacy Tours dates and book your tickets online. Historic, haunted, underground &amp; food tours in Cincinnati, Newport &amp; Covington."
        path="/event-calendar"
      />

      {/* --- Header --- */}
      <div style={{
        position: "relative",
        background: "var(--brand-dark)",
        backgroundImage: "url('https://res.cloudinary.com/american-legacy-tours/image/upload/c_fill,h_500,w_1800/f_auto,q_auto/img/home/slider/slider-04')",
        backgroundSize: "cover",
        backgroundPosition: "center top",
        padding: "40px 0 32px",
      }}>
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.55) 100%)", zIndex: 0 }} />
        <Container style={{ position: "relative", zIndex: 1 }}>
          <h1 style={{ color: "#fff", fontWeight: 800, margin: "0 0 6px", fontSize: "clamp(1.5rem, 4vw, 2.2rem)", lineHeight: 1.2 }}>
            Tour Calendar
          </h1>
          <p style={{ color: "rgba(255,255,255,0.55)", margin: 0, fontSize: "0.9rem" }}>
            Browse all upcoming tour dates and book your spot
          </p>
        </Container>
      </div>

      {/* --- Body --- */}
      <section style={{ background: "#f8f7f4", padding: "40px 0 72px" }}>
        <Container>
          <Row>
            <Col>
              <div style={{ background: "#fff", borderRadius: 8, overflow: "hidden", boxShadow: "var(--shadow-card)", position: "relative" }}>
                {!iframeReady && (
                  <div style={{ padding: "60px 0", textAlign: "center" }}>
                    <Spinner animation="border" role="status" style={{ color: "var(--brand-orange)", width: 40, height: 40 }}>
                      <span className="sr-only">Loading calendar...</span>
                    </Spinner>
                    <p style={{ color: "#999", marginTop: 16, fontSize: "0.88rem" }}>Loading tour dates…</p>
                  </div>
                )}
                <iframe
                  title="Tour Event Calendar"
                  src="https://americanlegacytours.thundertix.com/events/"
                  width="100%"
                  height="3000"
                  frameBorder="0"
                  scrolling="auto"
                  onLoad={() => setIframeReady(true)}
                  style={{ display: iframeReady ? "block" : "none" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Calendar;
